import React from 'react';
import PropTypes from 'prop-types';
import Dotdotdot from 'react-dotdotdot';
import Link from 'gatsby-link';
import './publication.css';


class Publication extends React.Component {


  static propTypes = {
    title: PropTypes.string.isRequired,
    authors: PropTypes.string.isRequired,
    journal: PropTypes.string.isRequired,
    year: PropTypes.string.isRequired,
    abstract: PropTypes.string.isRequired,
    link: PropTypes.string,
    linkText: PropTypes.string
  }

  static defaultProps = {
    title: "Hello World",
    year: "2016",
    authors: "G. Yushin",
    abstract: "The abstract of the paper goes here"
  }

  render() {

    return (
      <div className={"publication-container col-xs-12 col-sm-12 col-md-12 col-lg-offset-1 col-lg-10 col-xl-10"}>
        <a href={this.props.link}>
        <div className={"publication"}>
          <div className={"title"}>
            <h4>{this.props.title}</h4>
            <p>{this.props.year}</p>
          </div>
          <span className="journal">{this.props.journal}{'\n'}</span>
          <p className="authors">{this.props.authors}</p>
          <Dotdotdot clamp={2}>
            <p className="abstract">{this.props.abstract}</p>
          </Dotdotdot>
        </div>
        </a>
      </div>
    )
  }
}

export default Publication;



// WEBPACK FOOTER //
// ./src/components/Publication/publication.js